export const version = 'v1';
export const v2 = 'v2';

export const RELATORIO_ENDPOINT = `${version}/relatorio`;
export const CHANGELOG_ENDPOINT = `${version}/changelog`;
